/** Besper-native Stripe provider ids (see marketplace PROVIDERS). */
export const BESPER_VENDOR_PROVIDER_IDS = [
  'besper_finance',
  'besper_products',
  'besper_ai',
  'besper_storage',
];

/**
 * @param {string|null|undefined} id
 * @returns {boolean}
 */
export function isBesperVendorProviderId(id) {
  if (id == null || typeof id !== 'string') {
    return false;
  }
  return BESPER_VENDOR_PROVIDER_IDS.includes(id.trim().toLowerCase());
}
